function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAnime(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 29,
    viewBox: "0 0 28 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M0 14.5C0 6.76801 6.26801 0.5 14 0.5V0.5C21.732 0.5 28 6.76801 28 14.5V14.5C28 22.232 21.732 28.5 14 28.5V28.5C6.26801 28.5 0 22.232 0 14.5V14.5Z",
    fill: "white",
    fillOpacity: 0.2,
    style: {
      fill: "white",
      fillOpacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.3191 8.01506C16.9281 7.27786 15.3509 6.93027 13.7656 7.0116C12.1804 7.09292 10.6504 7.59991 9.34854 8.47525C7.67834 9.71828 6.48678 11.4631 5.96295 13.4329C5.43911 15.4027 5.61299 17.4846 6.457 19.3483C6.51698 19.4926 6.60586 19.624 6.71857 19.7352C6.83128 19.8463 6.96561 19.935 7.11388 19.9961C7.26216 20.0573 7.42148 20.0897 7.58275 20.0915C7.74402 20.0933 7.90408 20.0645 8.05379 20.0067C8.20351 19.9489 8.33994 19.8633 8.4553 19.7547C8.57066 19.6461 8.6627 19.5166 8.72615 19.3738C8.7896 19.2309 8.82322 19.0774 8.8251 18.922C8.82697 18.7666 8.79707 18.6124 8.73708 18.4682C8.09629 17.1003 7.94698 15.5656 8.31278 14.1068C8.67857 12.6479 9.53859 11.3482 10.7569 10.413C11.6731 9.79179 12.7512 9.42941 13.8698 9.3667C14.9883 9.304 16.1027 9.54347 17.0876 10.0581C17.2104 10.1244 19.9705 11.7001 19.8723 14.4471C19.806 16.3305 18.3989 18.5155 16.411 18.7687C15.7779 18.8608 15.1307 18.7683 14.5526 18.5031C13.9745 18.2379 13.492 17.8121 13.1671 17.2804C12.6981 16.2619 12.9829 14.8091 13.7209 14.4566C14.1429 14.3185 14.6032 14.3362 15.0125 14.5063C15.1637 14.5606 15.3245 14.5858 15.4858 14.5803C15.647 14.5748 15.8056 14.5387 15.9524 14.4742C16.0991 14.4097 16.2313 14.3179 16.3413 14.2041C16.4513 14.0904 16.5369 13.9569 16.5934 13.8112C16.6498 13.6656 16.6759 13.5107 16.6702 13.3553C16.6645 13.1999 16.6271 13.0472 16.5601 12.9057C16.4931 12.7643 16.3979 12.637 16.2798 12.531C16.1618 12.425 16.0232 12.3425 15.872 12.2881C15.3579 12.082 14.8053 11.9799 14.2485 11.9883C13.6917 11.9966 13.1427 12.1152 12.6355 12.3366C10.499 13.3576 10.0202 16.2666 10.9263 18.2387C11.3931 19.1424 12.119 19.8983 13.0179 20.4168C13.9169 20.9353 14.9512 21.1947 15.9985 21.1643C16.2448 21.1646 16.4909 21.1491 16.7352 21.1181C20.0602 20.6958 22.2285 17.3715 22.3292 14.5323C22.4716 10.4544 18.7451 8.25284 18.3191 8.01506Z",
    fill: "url(#paint0_linear_4889_57701)",
    style: {}
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4889_57701",
    x1: 17.3871,
    y1: 7,
    x2: 17.3871,
    y2: 20.7395,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A377FF",
    style: {
      stopColor: "#A377FF",
      stopColor: "color(display-p3 0.6378 0.4686 1.0000)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#48278F",
    style: {
      stopColor: "#48278F",
      stopColor: "color(display-p3 0.2815 0.1511 0.5608)",
      stopOpacity: 1
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnime);
export default __webpack_public_path__ + "static/media/anime.907cb4db3073a7989d0e477108506015.svg";
export { ForwardRef as ReactComponent };